<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.external_project')"
    icon="res-billexternalproject"
    :res-name="detailData.external_project_name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :hiddenKindTabs="['external_project', 'project_tag']"
      :defaultExternalProjectName="listRowData.external_project_name"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CloudExternalprojectSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillExternalProjectSidePage'
        default:
          return ''
      }
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || ''
      return { dateParam, dateMode }
    },
  },
}
</script>
